import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopandharpurtaxi() {



const cardData = {
  keyword: "Pune to Pandharpur Taxi",
  heading: "Lotus Cab: Pune to Pandharpur Taxi",

  headingDescription:
    "Lotus Cab offers safe, reliable, and comfortable Pune to Pandharpur taxi services for devotees, families, and corporate travelers. Whether you are planning a Vitthal Rukmini Temple darshan, same-day return pilgrimage, or a peaceful weekend spiritual trip, our AC sedan and SUV fleet ensures smooth highway travel. Our professional drivers are experienced with Pune–Pandharpur routes and temple travel schedules. We provide transparent per-km pricing with flexible one-way and round-trip options. With 24/7 booking assistance and punctual pickup across Pune, Lotus Cab makes your Pandharpur journey convenient, affordable, and spiritually fulfilling.",

  top: "Top Places to Visit in Pandharpur with Lotus Cab",

  topPlaces: [
    {
      title: "Shri Vitthal Rukmini Temple",
      description:
        "Vitthal Rukmini Temple is the most sacred pilgrimage destination in Pandharpur. Dedicated to Lord Vitthal and Goddess Rukmini. Thousands of devotees visit throughout the year. Ashadhi and Kartiki Ekadashi attract large crowds. Pune to Pandharpur taxi ensures timely darshan. Lotus Cab provides safe and comfortable temple travel."
    },
    {
      title: "Chandrabhaga River",
      description:
        "Chandrabhaga River flows near the temple complex. Devotees take holy dips before darshan. Spiritual atmosphere surrounds the riverbanks. Ideal for peaceful meditation. Convenient access with cab service. Lotus Cab offers smooth local travel."
    },
    {
      title: "Pundalik Temple",
      description:
        "Pundalik Temple holds great religious significance. Associated with Lord Vitthal’s origin story. Located near the main temple. Frequently visited by pilgrims. Comfortable travel available with Lotus Cab."
    },
    {
      title: "Namdev Payari",
      description:
        "Namdev Payari is a sacred step within Vitthal Temple. Devotees consider it spiritually powerful. Part of traditional darshan path. Accessible easily with cab service. Lotus Cab ensures flexible temple visit schedule."
    },
    {
      title: "Kaikadi Maharaj Math",
      description:
        "Important spiritual math in Pandharpur. Known for devotional activities. Visitors seek blessings and spiritual guidance. Pune to Pandharpur cab makes visit comfortable."
    },
    {
      title: "ISKCON Pandharpur",
      description:
        "ISKCON Temple in Pandharpur attracts devotees. Peaceful devotional environment. Popular among spiritual seekers. Lotus Cab offers comfortable access."
    },
    {
      title: "Dnyaneshwar Temple",
      description:
        "Temple dedicated to Sant Dnyaneshwar. Important pilgrimage spot. Frequently visited during yatra seasons. Safe cab travel recommended."
    },
    {
      title: "Pandharpur Market Area",
      description:
        "Local market known for religious souvenirs and prasad items. Devotees shop after darshan. Easily accessible with cab. Lotus Cab provides flexible local trip."
    }
  ],

  services: [
    {
      name: "Pune to Pandharpur Taxi",
      description:
        "Reliable Pune to Pandharpur taxi service for temple darshan and spiritual travel. AC sedan and SUV options available. Experienced drivers assigned. Transparent per-km pricing maintained. Safe highway journey ensured."
    },
    {
      name: "Pune to Pandharpur One Way Cab",
      description:
        "Affordable one-way cab from Pune to Pandharpur. Pay only for single distance. Ideal for personal and pilgrimage travel. Comfortable AC vehicles provided."
    },
    {
      name: "Pune to Pandharpur Round Trip Taxi",
      description:
        "Flexible round-trip taxi option for same-day return. Perfect for darshan visits. Transparent fare structure maintained. Professional drivers ensure safe travel."
    },
    {
      name: "Pandharpur Darshan Cab from Pune",
      description:
        "Specialized darshan cab package from Pune. Timely temple drop ensured. Experienced drivers familiar with temple area. Comfortable vehicles available."
    },
    {
      name: "Luxury Taxi Pune to Pandharpur",
      description:
        "Premium luxury cab options for executive and VIP pilgrimage travel. Spacious interiors and smooth ride experience. Professional chauffeurs assigned."
    },
    {
      name: "SUV Cab Pune to Pandharpur",
      description:
        "Spacious SUV taxi ideal for family pilgrimage trips. Extra luggage space available. Safe long-distance travel ensured."
    },
    {
      name: "Sedan Taxi Pune to Pandharpur",
      description:
        "Budget-friendly sedan cab for individuals and small families. AC vehicles maintained. Transparent pricing policy followed."
    },
    {
      name: "Online Cab Booking Pune to Pandharpur",
      description:
        "Instant online booking available for Pandharpur taxi service. Quick confirmation and 24/7 support provided."
    }
  ],

  tableData: [
    ["Pune to Pandharpur Taxi", "Pune to Pandharpur Cab Service"],
    ["Pune to Pandharpur One Way Cab", "Pune to Pandharpur Round Trip Taxi"],
    ["Pandharpur Darshan Cab from Pune", "Pune to Vitthal Rukmini Temple Taxi"],
    ["Affordable Pune to Pandharpur Cab", "Luxury Taxi Pune to Pandharpur"],
    ["SUV Cab Pune to Pandharpur", "Sedan Taxi Pune to Pandharpur"],
    ["Family Trip Cab Pune to Pandharpur", "Corporate Taxi Pune to Pandharpur"],
    ["Same Day Pandharpur Cab", "AC Taxi Pune to Pandharpur"],
    ["Online Cab Booking Pune to Pandharpur", "Best Cab Service Pune to Pandharpur"],
    ["Outstation Cab Pune to Pandharpur", "Pune to Pandharpur Per Km Rate"],
    ["Cheap Taxi Pune to Pandharpur", "Weekend Trip Cab Pune to Pandharpur"]
  ],

  whychoose: [
    { WhyChooseheading: "Safe Pilgrimage Travel", WhyChoosedescription: "Experienced drivers ensure smooth Pune to Pandharpur highway travel." },
    { WhyChooseheading: "Transparent Per Km Pricing", WhyChoosedescription: "Clear fare structure with no hidden charges." },
    { WhyChooseheading: "Comfortable AC Vehicles", WhyChoosedescription: "Well-maintained sedan and SUV fleet available." },
    { WhyChooseheading: "Flexible One-Way & Round Trip", WhyChoosedescription: "Choose travel option as per your schedule." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock booking assistance available." },
    { WhyChooseheading: "Temple-Focused Service", WhyChoosedescription: "Timely drop near Vitthal Temple ensured." },
    { WhyChooseheading: "Family-Friendly Travel", WhyChoosedescription: "Spacious vehicles suitable for group pilgrimage." },
    { WhyChooseheading: "Professional Chauffeurs", WhyChoosedescription: "Trained drivers familiar with temple routes." }
  ]
};

const faqData = [
  { question: "Do you provide one-way Pune to Pandharpur taxi?", answer: "Yes, affordable one-way cab available." },
  { question: "Is same-day return possible?", answer: "Yes, same-day round trip option available." },
  { question: "Are vehicles AC?", answer: "Yes, all vehicles are air-conditioned." },
  { question: "Is 24/7 booking available?", answer: "Yes, booking available anytime." },
  { question: "Are drivers experienced?", answer: "Yes, trained long-distance drivers assigned." },
  { question: "Do you offer SUV option?", answer: "Yes, SUV cabs available for families." },
  { question: "Is temple drop provided?", answer: "Yes, drop near Vitthal Temple provided." },
  { question: "Are toll charges included?", answer: "Toll charges informed transparently." },
  { question: "Is online booking available?", answer: "Yes, instant booking available." },
  { question: "Do you provide corporate taxi?", answer: "Yes, corporate travel support available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Anil Jadhav",
    feedback:
      "Booked Pune to Pandharpur taxi for Vitthal darshan. Smooth and safe journey with punctual driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita More",
    feedback:
      "Very comfortable SUV for family pilgrimage trip. Transparent pricing and professional service.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Used Lotus Cab for staff pilgrimage travel. Excellent coordination and reliable highway service.",
    rating: 5
  }
];





































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pandharpur Taxi",
  "image": "https://lotuscab.com/assets/images/pune-to-pandharpur-taxi.jpg", 
  "description": "Lotus Cab offers Pune to Pandharpur taxi services including one way, round trip, and outstation options. Travel comfortably to Pandharpur Darshan and Vitthal Rukmini Temple with sedan, SUV, and luxury cabs for family, corporate, weekend, and same-day trips, all with professional drivers and reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-pandharpur-taxi"
  }
};








  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune to Pandharpur Taxi | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Pandharpur taxi with Lotus Cab. Affordable one way, round trip & outstation cabs to Pandharpur Darshan & Vitthal Rukmini Temple. Family & corporate trips available. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Pandharpur Taxi, Pune to Pandharpur Cab Service, Pune to Pandharpur One Way Cab, Pune to Pandharpur Round Trip Taxi, Pandharpur Darshan Cab from Pune, Pune to Vitthal Rukmini Temple Taxi, Affordable Pune to Pandharpur Cab, Luxury Taxi Pune to Pandharpur, SUV Cab Pune to Pandharpur, Sedan Taxi Pune to Pandharpur, Family Trip Cab Pune to Pandharpur, Corporate Taxi Pune to Pandharpur, Same Day Pandharpur Cab, AC Taxi Pune to Pandharpur, Online Cab Booking Pune to Pandharpur, Best Cab Service Pune to Pandharpur, Outstation Cab Pune to Pandharpur, Pune to Pandharpur Per Km Rate, Cheap Taxi Pune to Pandharpur, Weekend Trip Cab Pune to Pandharpur" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopandharpurtaxi;